module.exports = __webpack_public_path__ + "img/roboexplain.15803379.jpg";